export const scrollToElement = (id: string) => {
    const itemEl = document.getElementById(id);
    setTimeout(() => {
        if (itemEl && itemEl.scrollIntoView) {
            itemEl.scrollIntoView();
            itemEl.focus();
        }
    }, 200);
};

/* Necessary until we fix the return from add folder */
export const scrollToFolderElementByName = (text: string) => {
    setTimeout(() => {
        const menu = document.getElementById('filterOptionsContainer');
        if (menu) {
            const itemEl = Array.from(menu.querySelectorAll('span')).find((item) => item.textContent?.startsWith(text));
            if (itemEl && itemEl.scrollIntoView) {
                itemEl.scrollIntoView();
                itemEl.focus();
            }
        }
    }, 200);
};

export const focusContextualMenuSearchBox = () => {
    const itemEl = document.querySelector('#filterOptionsContainer input') as HTMLElement;

    setTimeout(() => {
        if (itemEl) {
            itemEl.focus();
        }
    }, 200);
};
